import { render, staticRenderFns } from "./ProjectInvalid.vue?vue&type=template&id=58278eec"
import script from "./ProjectInvalid.vue?vue&type=script&lang=js"
export * from "./ProjectInvalid.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports